export interface WorkspaceIntegrationFetchScope {
    workspaceId: string | null;
    generation: number;
}

const normalizeWorkspaceId = (workspaceId?: string): string | null => (
    workspaceId || null
);

export const createWorkspaceIntegrationFetchScope = (
    workspaceId?: string
): WorkspaceIntegrationFetchScope => ({
    workspaceId: normalizeWorkspaceId(workspaceId),
    generation: 0,
});

export const advanceWorkspaceIntegrationFetchScope = (
    currentScope: WorkspaceIntegrationFetchScope,
    workspaceId?: string
): WorkspaceIntegrationFetchScope => {
    const nextWorkspaceId = normalizeWorkspaceId(workspaceId);
    if (currentScope.workspaceId === nextWorkspaceId) {
        return currentScope;
    }

    return {
        workspaceId: nextWorkspaceId,
        generation: currentScope.generation + 1,
    };
};

export const invalidateWorkspaceIntegrationFetchScope = (
    currentScope: WorkspaceIntegrationFetchScope
): WorkspaceIntegrationFetchScope => ({
    workspaceId: null,
    generation: currentScope.generation + 1,
});

export const isSameWorkspaceIntegrationFetchScope = (
    left: WorkspaceIntegrationFetchScope,
    right: WorkspaceIntegrationFetchScope
): boolean => (
    left.workspaceId === right.workspaceId
    && left.generation === right.generation
);

export const hasFreshWorkspaceIntegrationSnapshot = (
    currentScope: WorkspaceIntegrationFetchScope,
    fetchedScope: WorkspaceIntegrationFetchScope | null
): boolean => Boolean(
    currentScope.workspaceId
    && fetchedScope
    && isSameWorkspaceIntegrationFetchScope(currentScope, fetchedScope)
);
